export enum ValidNotificationTypes {
  SERVICE_REQUEST_STATUS_CHANGED = "service_request_status_changed",
  SERVICE_REQUEST_NON_ASSIGNEE_COMMENT_ADDED = "service_request_non_assignee_comment_added",
  SERVICE_REQUEST_ASSIGNED = "service_request_assigned",
  SERVICE_REQUEST_UNASSIGNED = "service_request_unassigned",
  SERVICE_REQUEST_NEW_ATTACHMENT = "service_request_new_attachment",
  SERVICE_REQUEST_OVERDUE = "service_request_overdue",
}
